import { Avatar, Box, Grid, Tooltip, useMediaQuery, Switch, SwitchProps, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import Card from "shared/components/card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import GroupIcon from "@mui/icons-material/Group";
import CreateIcon from "@mui/icons-material/Create";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import styles from "./style.module.scss";
import { Icons, Images } from "assets";
import Pagination from "shared/components/pagination";

import EditIcon from "@mui/icons-material/Edit";
import Filter from "shared/components/filterButton";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routesConstant";
import useWindowSize from "shared/customHooks/windowSize";
import { getAllAuthorsService, getAuthorStatsService, updateAuthorDistinguishService } from "shared/services/productManagerService";
import { toastMessage } from "shared/components/toast";
import useDebounce from "shared/customHooks/useDebounce";
import SkeletonLoader from "./skeletonLoader";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import ItemsPerPage from "shared/components/itemsPerPage";
import EditAuthorProfile from "shared/modals/editAuthorProfile";
import DistinguishConfirmation from "shared/modals/distinguishConfirmation";

function AuthorsListing() {
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState<number>(1);
  const screenWidth = useWindowSize();
  // const [totalPage, setTotalPage] = useState<number>(10);
  const widthTablet = useMediaQuery("(max-width:767px)");
  const [dashboardData, setDashboardData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [allAuthors, setAllAuthors] = useState<any>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const [searchText, setSearchText] = useState<string>("");
  const [totalPage, setTotalPage] = useState<number>(0);
  const [selectedFilter, setSelectedFilter] = useState<any>(null);
  const [totalItems, setTotalItems] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [selectedAuthorId, setSelectedAuthorId] = useState<number | null>(null);
  const [selectedAuthorProfilePic, setSelectedAuthorProfilePic] = useState<string | undefined>(undefined);
  const [openDistinguishModal, setOpenDistinguishModal] = useState<boolean>(false);
  const [distinguishAuthorId, setDistinguishAuthorId] = useState<number | null>(null);
  const [distinguishStatus, setDistinguishStatus] = useState<boolean>(false);
  const [distinguishLoader, setDistinguishLoader] = useState<boolean>(false);

  const cardData = [
    {
      title: "All Authors",
      icon: GroupIcon,
      stats: dashboardData?.total_authors,
    },
    {
      title: "Individual Authors",
      icon: GroupIcon,
      stats: dashboardData?.individual_authors,
    },
    {
      title: "Partner  Authors",
      icon: GroupIcon,
      stats: dashboardData?.partner_authors,
    },
    {
      title: "General Authors",
      icon: GroupIcon,
      stats: dashboardData?.non_distinguish_book_authors,
    },
    {
      title: "Distinguished Authors",
      icon: GroupIcon,
      stats: dashboardData?.distinguish_book_authors,
    },


  ];

  const filterOption = [
    {
      option: "All Authors",
      value: null,
    },
    {
      option: "Distinguished Authors",
      value: 1,
    },
    {
      option: "General Authors",
      value: 0,
    },
  ];

  const getStats = () => {
    setIsLoading(true);
    getAuthorStatsService()
      .then(({ data }) => {
        setIsLoading(false);
        console.log("data", data);
        setDashboardData(data?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        toastMessage("error", err?.response?.data?.message);
        console.log("err", err?.response?.data?.message);
      });
  };

  useEffect(() => {
    getStats();
  }, []);

  const getAllAuthors = () => {
    setLoader(true);
    getAllAuthorsService(
      searchText,
      selectedFilter?.value,
      activePage,
      itemsPerPage
    )
      .then(({ data }) => {
        setLoader(false);
        setTotalPage(data?.data?.last_page);
        setAllAuthors(data?.data?.data);
        // setTotalPage(data?.data?.last_page);
        setTotalItems(data?.data?.total);
        setItemsPerPage(data?.data?.per_page);
        setCurrentPage(data?.data?.current_page);
      })
      .catch((err) => {
        toastMessage("error", err?.response?.data?.message);
        console.log("err", err?.response?.data?.message);
        setLoader(false);
      });
  };

  useEffect(() => {
    getAllAuthors();
    // eslint-disable-next-line
  }, [searchText, selectedFilter, activePage, itemsPerPage]);

  useDebounce(
    () => {
      const trimmedSearch = search.trim();
      if (trimmedSearch === searchText) return;
      setSearchText(trimmedSearch);
      setActivePage(1);
    },
    [search],
    800
  );

  useBreadcrumbs({
    title: "Authors",
    path: routeConstant.author.path,
  });

  const handleDistinguishToggle = (authorId: number, checked: boolean) => {
    setDistinguishAuthorId(authorId);
    setDistinguishStatus(checked);
    setOpenDistinguishModal(true);
  };

  const confirmDistinguishToggle = () => {
    if (!distinguishAuthorId) return;
    setDistinguishLoader(true);
    updateAuthorDistinguishService(distinguishAuthorId, distinguishStatus)
      .then(({ data }) => {
        setDistinguishLoader(false);
        toastMessage("success", data?.message || `Distinguish status ${distinguishStatus ? "enabled" : "disabled"} successfully`);
        setOpenDistinguishModal(false);
        setDistinguishAuthorId(null);
        getAllAuthors();
        getStats();
      })
      .catch((err) => {
        setDistinguishLoader(false);
        toastMessage("error", err?.response?.data?.message || "Failed to update distinguish status");
        setOpenDistinguishModal(false);
        setDistinguishAuthorId(null);
        getAllAuthors(); // Refresh to revert UI state
      });
  };

  return (
    <div>
      <Grid container spacing={2}>
        {cardData?.map((item) => {
          return (
            <Grid item xs={widthTablet ? 12 : 4}>
              <Card
                Icon={item?.icon}
                stats={item?.stats}
                title={item?.title}
                isLoading={isLoading}
              />
            </Grid>
          );
        })}
      </Grid>

      <Box className={styles.topLevelContainer}>
        <Box className={styles.topHeadContainer}>
          <Box>
            <div className={styles.tableHeading}>Authors</div>
            <div className={styles.tableSubHeading}>
              Effortlessly oversee Authors from here.{" "}
            </div>
          </Box>
          <Box className={styles.filterContainer}>
            <div className={styles.gridContainer}>
              <Icons.SearchIcon className={styles.searchIcon} />
              <input
                placeholder="Search"
                className={styles.input}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div>
              <Filter
                filterOption={filterOption}
                filterStyles={styles.filterStyles}
                selectedOption={selectedFilter}
                setSelectedOption={(option: any) => {
                  setSelectedFilter(option);
                  setActivePage(1);
                }}
              />
            </div>
          </Box>
        </Box>
        <TableContainer
          component={Paper}
          className={styles.table}
          sx={screenWidth > 990 ? { width: `${screenWidth - 300}px` } : {}}
        >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow className={styles.tableHead}>
                <TableCell>Publisher name</TableCell>
                <TableCell>Book Count</TableCell>
                <TableCell>Distinguish</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loader ? (
                <SkeletonLoader />
              ) : (
                allAuthors?.map((item: any) => {
                  return (
                    <TableRow className={styles.tableRow}>
                      <TableCell>
                        <Box display={"flex"} alignItems={"center"}>
                          <Avatar
                            src={item?.profile_pic || Images.User_Upload}
                            alt={item?.name || "Author"}
                            sx={{ width: 40, height: 40 }}
                            onError={(e: any) => {
                              e.target.src = Images.User_Upload;
                            }}
                          />
                          <span style={{ marginLeft: '10px' }}>{item?.name}</span>
                        </Box>
                      </TableCell>
                      <TableCell>{item?.books_count}</TableCell>
                      <TableCell>
                        <SwitchCustom
                          checked={item?.is_distinguish || false}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            handleDistinguishToggle(item?.id, e.target.checked);
                          }}
                          disabled={distinguishLoader}
                        />
                      </TableCell>
                      <TableCell>
                        <Box
                          display={"flex"}
                          alignItems={"center"}
                          className={styles.actionBtn}
                        >
                          <Tooltip arrow title="Edit Profile">
                            <button
                              onClick={() => {
                                setSelectedAuthorId(item?.id);
                                setSelectedAuthorProfilePic(item?.profile_pic);
                                setOpenEditModal(true);
                              }}
                            >
                              <EditIcon />
                            </button>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {totalPage > 1 && (
          <Pagination
            totalPages={totalPage}
            activePage={activePage}
            setActivePage={setActivePage}
          />
        )}
        {allAuthors?.length > 0 ? (
          <ItemsPerPage
            setActivePage={setActivePage}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            totalItems={totalItems}
          ></ItemsPerPage>
        ) : null}
      </Box>

      <EditAuthorProfile
        open={openEditModal}
        handleClose={() => {
          setOpenEditModal(false);
          setSelectedAuthorId(null);
          setSelectedAuthorProfilePic(undefined);
        }}
        authorId={selectedAuthorId}
        getAllAuthors={getAllAuthors}
        initialProfilePic={selectedAuthorProfilePic}
      />

      <DistinguishConfirmation
        open={openDistinguishModal}
        handleClose={() => {
          setOpenDistinguishModal(false);
          setDistinguishAuthorId(null);
        }}
        handleClick={confirmDistinguishToggle}
        heading="Distinguish Author"
        text={`Are you sure you want to ${distinguishStatus ? "enable" : "disable"} distinguish status for this author?`}
        loader={distinguishLoader}
      />
    </div>
  );
}

// Custom styled switch for iOS-like appearance
const SwitchCustom = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 1,
    margin: 1,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#9a469b" : "#9a469b",
        opacity: 1,
        border: 0,
      },
      "& .MuiSwitch-thumb": {
        boxShadow: "0 3px 8px rgba(0, 0, 0, 0.24)",
      },
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.5,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "dark" ? "#39393D" : "#d7d7d7e3",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export default AuthorsListing;
